import type { Release } from '../releases';

export default {
  id: '2026-10-31-shift-tasks',
  at: '2026-11-01T04:58:00Z',
  title: 'Сменное задание прорабу с объёмом на день',
  modules: ['schedule', 'site'],
  items: [
    'В графике, на вкладке недельного плана, — блок «Сменные задания прорабам»: работа из обязательств недели, день смены, прораб и объём на день.',
    'Объём на день портал считает сам: равномерно по рабочим дням календаря работы (выходные и праздники пропускаются) или по ресурсной кривой назначений; его можно указать вручную.',
    'Прораб видит задание в «Моём дне» как пакет дня и сдаёт по нему отчёт смены; принятый отчёт меняет факт работы в графике, а в задании видно, сколько принято.',
    'Задание видят только назначенный прораб и руководство проекта; отменить его можно, пока по нему нет отчёта.',
  ],
  why: 'Недельный план доходил до прораба только пакетом на одну-две недели без объёма на день: прораб не знал, сколько сделать за смену, а отчёт нельзя было сверить с заданием.',
  link: '/schedule',
} satisfies Release;
